import { IndicatorStyle } from "./style";

export default function Indicator({ edge }: { edge: string }) {
    return <IndicatorStyle className={edge}>Place it here</IndicatorStyle>;
}
